import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals.js";
import { AuthProvider } from "./context/AuthContext.js";
import { GlobalSearchProvider } from "./context/GlobalSearchContext.jsx";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const root = ReactDOM.createRoot(document.getElementById("root"));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GlobalSearchProvider>
          <App />
        </GlobalSearchProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// React query dev tools = <ReactQueryDevtools /> & import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

reportWebVitals();
